// stockouts/create

import { postCall } from "./axiosCalls";

export const stockIn = async (values) => {
    try {
        const response = await postCall(
          process.env.REACT_APP_API_LINK + "/stockins/create", // Ex. "/racks/create"
          {
            requester: 1,
            token: 'sample token',
            ...values
          }
        );
        console.log(response);
        return { data: response.data };
    } catch (error) {
        console.log(error)
        return { error: error.response };
    } 
}

export const stockOut = async (qr_code) => {
    try {
        const response = await postCall(
          process.env.REACT_APP_API_LINK + "/stockouts/create",
          {
            requester: 1,
            token: 'sample token',
            qr_code: qr_code
          }
        );
        console.log(response);
        return { data: response.data };
    } catch (error) {
        console.log(error)
        return { error: error.response };
    } 
}
